import { MatDialogConfig } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { ConfirmDialogData } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { NewAssessmentComponent } from '../new-assessment/new-assessment.component';

export const discardLinkDialogData: MatDialogConfig<ConfirmDialogData> = {
  data: {
    title: 'Leave page?',
    message: 'Leaving this page will lose the data provided via the link. Are you sure you want to leave?',
  },
};

export const discardLinkDataGuard: CanDeactivateFn<NewAssessmentComponent> = component => {
  return component.confirmLeave();
};
